import React from 'react';

import CampaignTeaser from './Teaser';
import CampaignFull from './Full';

const Campaign = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <CampaignTeaser {...props} />;
  }

  return <CampaignFull {...props} />;
};

export default Campaign;
